import { publicUrl } from 'modules/core/utils/routing';

export const STATIC_IMAGE_URLS = {
  logo: publicUrl('/static/images/logo-image.png'),
  logoWhite: publicUrl('/static/images/streamline-logo-white.png'),
  logoDark: publicUrl('/static/images/streamline-logo-dark.png'),
  loginBackground: publicUrl('/static/images/login-background-image.jpg'),
  logoLoginBackground: publicUrl('/static/images/logo-login-background.svg'),
  learningBackground: publicUrl('/static/images/learning-background.jpg'),
  racLogo: publicUrl('/static/images/rac-logo.png'),
  unlockInventoryVertical: publicUrl('/static/images/unlockInventoryVertical.png'),
  icons: {
    eye: publicUrl('/static/images/eye.png'),
    closedEye: publicUrl('/static/images/closed-eye.png'),
    mail: publicUrl('/static/images/mail-image.png'),
    questionMark: publicUrl('/static/images/question-mark.png'),
    congrats: publicUrl('/static/images/congrats-image.png'),
    calculator: publicUrl('/static/images/awesome-calculator.svg'),
    car: publicUrl('/static/images/car.png'),
    noPhoto: publicUrl('/static/images/noPhoto.png'),
    dashboard: publicUrl('/static/images/dashboard-icon.png'),
    house: publicUrl('/static/images/house.png'),
    message: publicUrl('/static/images/message.png'),
    play: publicUrl('/static/images/play-icon-white.svg'),
    print: publicUrl('/static/images/feather-printer.svg'),
    user: publicUrl('/static/images/user-icon-white.svg'),
    info: publicUrl('/static/images/info.svg'),
    infoV2: publicUrl('/static/images/info-v2.svg'),
    infoOrange: publicUrl('/static/images/info-orange.svg'),
    success: publicUrl('/static/images/success.svg'),
    table: publicUrl('/static/images/table.svg'),
    cards: publicUrl('/static/images/cards.svg'),
    trash: publicUrl('/static/images/trash.svg'),
    calendar: publicUrl('/static/images/calendar-blue.svg'),
    filter: publicUrl('/static/images/filter.svg'),
    highlightedFilter: publicUrl('/static/images/highlightedFilter.svg'),
    backArrow: publicUrl('/static/images/back-arrow.png'),
    downArrow: publicUrl('/static/images/down-arrow.png'),
    arrowIcon: publicUrl('/static/images/arrowIcon.svg'),
    undoIcon: publicUrl('/static/images/undo-blue.svg'),
    whiteUndo: publicUrl('/static/images/whiteUndo.png'),
    fillCircle: publicUrl('/static/images/fillCircle.svg'),
    blackCar: publicUrl('/static/images/blackCar.png'),
    blackCarCard: publicUrl('/static/images/blackCarCard.png'),
    blackCarManuallyCreated: publicUrl('/static/images/blackCarManuallyCreated.png'),
    blackCarManuallyCreatedCard: publicUrl('/static/images/blackCarManuallyCreatedCard.png'),
    whiteCar: publicUrl('/static/images/whiteCarNew.png'),
    whiteCarCard: publicUrl('/static/images/whiteCarCard.png'),
    lockWhiteBackground: publicUrl('/static/images/lockWhiteBackground-blue.svg'),
    unlockWhiteBackground: publicUrl('/static/images/unlockWhiteBackground-blue.svg'),
    search: publicUrl('/static/images/search-blue.svg'),
    searchGray: publicUrl('/static/images/search-gray.svg'),
    successSubmit: publicUrl('/static/images/successSubmit.svg'),
    arrowRight: publicUrl('/static/images/arrow-right-blue.svg'),
    arrowRightWhite: publicUrl('/static/images/arrow-right-white.svg'),
    arrowRightGreen: publicUrl('/static/images/arrow-right-green.svg'),
    outOfPolicyRed: publicUrl('/static/images/out-of-policy-red.svg'),
    invalidInfoRed: publicUrl('/static/images/invalid-info-red.svg'),
    inPolicyGreen: publicUrl('/static/images/in-policy-green.svg'),
    settings: publicUrl('/static/images/advance-search-blue.svg'),
    sparkles: publicUrl('/static/images/sparkles.svg'),
    caretDown: publicUrl('/static/images/caret_down.svg'),
    modalCloseIcon: publicUrl('/static/images/modalClose.svg'),
    externalLink: publicUrl('/static/images/external-link.svg'),
    externalLinkWhite: publicUrl('/static/images/external-link-white.svg'),
    externalLinkGrey: publicUrl('/static/images/external-link-grey.svg'),
    checkBlueCompletion: publicUrl('/static/images/check-blue-completion.png'),
    checkBlueSmallCompletion: publicUrl('/static/images/check-blue-completion-small.png'),
    incomeCalculator: publicUrl('/static/images/income-calculator.svg'),
    filterInventory: publicUrl('/static/images/filter_inventory.svg'),
  },
  sideBar: {
    probabilityEstimator: publicUrl('/static/images/probability-estimator-blue.svg'),
    approvedLoanInput: publicUrl('/static/images/approved-loan-input-blue.svg'),
    creditInterview: publicUrl('/static/images/interview-blue.svg'),
    adminPanel: publicUrl('/static/images/admin-panel-blue.svg'),
    rac: publicUrl('/static/images/rac-blue.svg'),
  },
  cars: {
    chevrolet: publicUrl('/static/images/chevy-traverse.png'),
    bmw: publicUrl('/static/images/bmw-z4.png'),
    car1: publicUrl('/static/images/car1.jpg'),
    car2: publicUrl('/static/images/car2.jpg'),
    car3: publicUrl('/static/images/car3.jpg'),
    car4: publicUrl('/static/images/car4.jpg'),
    car5: publicUrl('/static/images/car5.jpg'),
    car6: publicUrl('/static/images/car6.jpg'),
  },
  errorBackground: {
    bigger: publicUrl('/static/images/biggerErrorBackground.png'),
    smaller: publicUrl('/static/images/smallerErrorBackground.png'),
  },
  ssoErrorModalRouteOne: publicUrl('/static/images/RouteOne_eDPA_Screen.png'),
  ssoErrorDealertrackLogo: publicUrl('/static/images/dealertrack-banner.svg'),
  addInventoryLogo: publicUrl('/static/images/add-inventory-logo.png'),
  getInventoryLogo: publicUrl('/static/images/get-inventory-logo.png'),
  syncInventoryLogo: publicUrl('/static/images/sync-inventory-logo.png'),
  addInventoryModalLogo: publicUrl('/static/images/add-inventory-modal-logo.png'),
  backgroundWaves: publicUrl('/static/images/background-waves.png'),
};
